<vectronic-card
  [title]="'Belt ' + data.idDevice"
  [displayClose]="true"
  (closed)="dialogRef.close()"
>
  <ng-container body>
    <vectronic-belt-info [belt]="data.belt" />
  </ng-container>
</vectronic-card>
